var $ = require('jquery');
var _ = require('underscore');
var CMS = require('tscom-cms');

var DocumentView = require('./views/document');

require('./jQuery.XDomainRequest');

var globalOptions;

function customDocument(cmsModel) {

    var style_text = '';
    var data = cmsModel.get('data');
    var containerId = globalOptions.containerId;
    var container = $(globalOptions.container);

    //---------------------------------------
    if (data.use_branding_image === '0') {
        style_text = style_text + '#' + containerId + ' .logo{display:none;}';
    } else {
        style_text = style_text + '#' + containerId + ' .logo{display:block;}';
    }

    //---------------------------------------
    if (data.allow_scrollbars === '1') {
        container.parent().css('overflow','auto');
        style_text = style_text + '#' + containerId + '{overflow:auto;}';
    } else if (data.allow_scrollbars === '0') {
        container.parent().css('overflow','hidden');
        style_text = style_text + '#' + containerId + '{overflow:hidden;}';
    }

    //---------------------------------------
    if (data.copy_font_color !== '') {
        style_text = style_text + '#' + containerId + '{color:' + data.copy_font_color + ';}';
    }

    //---------------------------------------
    if (data.copy_link_color !== '') {
        style_text = style_text + '#' + containerId + ' a{color:' + data.copy_link_color + ';}';
    }

    //---------------------------------------
    if (data.font !== '') {
        style_text = style_text + '#' + containerId + '{font-family:' + data.font + ';}';
    }

    //---------------------------------------
    if (data.header_font_color !== '') {
        style_text = style_text + '#' + containerId + ' h1, #' + containerId + ' h2, #' + containerId + ' h3, #' + containerId + ' h4, #' + containerId + ' h5, #' + containerId + ' h6{color:' + data.header_font_color + ';}';
    }

    //---------------------------------------
    if (data.background_image !== '') {
        style_text = style_text + '#' + containerId + '{background:url(' + data.background_image + ');}';
    }

    //---------------------------------------
    if (typeof data.title !== 'undefined' && data.title !== '') {
        try {
            document.title = data.title;
        } catch (error) {

        }
    }

    //---------------------------------------
    var $design = $('<style/>').attr('id', containerId + 'Extend');
    $design.text(style_text);
    $('body').append($design);


    //---------------------------------------
    var docModel = new CMS({
        wid: data.document
    }, {
        ignoreQSP: true
    });
    docModel.once('change:ts', function(){
        docModel.on('change:data',
            function() {
                var view = new DocumentView({
                    model: docModel,
                    logo: data.branding_image
                });
                $(globalOptions.container).html(view.render().$el);
            });
    }).requestData();
};


function basicDocument(cmsModel) {

    var view = new DocumentView({
        model: cmsModel
    });
    $(globalOptions.container).html(view.render().$el);
};

module.exports = function init(options) {
    // Initial data setup
    globalOptions = options = options || {};
    options.container = options.container || $(document.body);
    options.widget_id = options.widget_id || 'c12030b6f2a5b96d';
    var containerId = $(options.container).attr('id');
    if (!containerId) {
        if (options.uniqueId) {
            containerId = options.uniqueId;
        } else {
            containerId = 'passion-meter-' + options.widget_id + '-' + (Date.now() % 1e6);
        }

        $(options.container).attr('id', containerId);
    }
    options.containerId = containerId;

    // The standard CMS data
    var cmsModel = new CMS({
        wid: options.widget_id
    }, {
        ignoreQSP: false
    });

    cmsModel.fetch().then(function(res) {

        var cmsType = res.snapshot.data.type;

        switch(cmsType) {
            case 'advanced':
            case 'advanced-2':
                cmsModel.on('change:data', customDocument);
                customDocument(cmsModel);
                break;
            case 'document':
            case 'document-2':
                cmsModel.on('change:data', basicDocument);
                basicDocument(cmsModel);
                break;
            default:
                console.log('Error: Invalid CMS type.');
        }
    });

    return options.container;
};
